import { atom } from "recoil";
import { sessionStorageEffect } from "./persistAtom";
import { defaultZoomSettings } from "../models/zoomSettings";

// all_zoom_setting 데이터 상태
export const zoomSettingsState = atom({
  key: "zoomSettingsState",
  default: defaultZoomSettings,
  effects: [sessionStorageEffect("zoomSettings")],
});

// 로딩 상태
export const zoomSettingsLoadingState = atom({
  key: "zoomSettingsLoadingState",
  default: false,
});

// 에러 상태
export const zoomSettingsErrorState = atom({
  key: "zoomSettingsErrorState",
  default: null,
});

// 초기화 완료 상태
export const zoomSettingsInitializedState = atom({
  key: "zoomSettingsInitializedState",
  default: false,
});
